import React from 'react'

import {
    paletaTonsAmarelo,
} from '../../../business-const/Color/Color'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import GraficoBarrasChart from './GraficoBarrasChart'



const ConsumoReservaAposentadoriaChart = ( { values, setFieldValue, estudo, vars, report, moreLessList } ) => {

    return (
        <GraficoBarrasChart
            values={values}
            setFieldValue={setFieldValue}
            estudo={estudo}
            vars={vars}
            report={report}
            grafico={estudo.current.graficoConsumoReservaAposentadoria}
            paletaTons={paletaTonsAmarelo}
            title={LABEL.consumoReservaAposentadoria}
            participacao={false}
            zoom={false}
            moreLessList={moreLessList}
            idListaMoreLess={HARDCODE.consumoReservaAposentadoriaChart}
        />
    )
}

export default ConsumoReservaAposentadoriaChart